import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import licensePlateService from '../services/licensePlate.service'
import downloadService from '../services/download.service'
import licensePlateApi, { LicensePlateData } from '../apis/licensePlate.api'
import confirmService from '../services/confirm.service'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import { ActionName } from '../components/Actions'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../components/TableHorizontal'
import Button from '../components/Button'
import HeadingRow from '../components/HeadingRow'

interface LicensePlatesProps extends RouteComponentProps {}

interface LicensePlatesState {
  licensePlates: TableHorizontalData<LicensePlateData>[]
}

class LicensePlates extends Component<LicensePlatesProps, LicensePlatesState> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Type"), path: 'applicableType' },
    { heading: i18n("Customer"), path: 'customer.name' },
    { heading: i18n("Customer site"), path: 'customerSite.name' },
    { heading: i18n("Total"), path: 'totalNumbers' },
    { heading: i18n("Remaining"), path: 'remainingNumbers' },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: ['updatedUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: LicensePlatesProps) {
    super(props)
    this.state = {
      licensePlates: []
    }
    this.handleUploadClick = this.handleUploadClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleUploadClick () {
    this.props.history.push(routes.licensePlateUpload)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'download') {
      this.handleDownload(id)
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the license plate?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handleDownload (id: number) {
    licensePlateApi.download(id, licensePlate => {
      if (!licensePlate) return
      downloadService.licensePlate(licensePlate)
    })
  }

  handleDeleteConfirm (id: number) {
    licensePlateApi.delete(id, licensePlate => {
      if (!licensePlate) return
      const licensePlates = licensePlateService.delete(this.state.licensePlates, id)
      this.setState({ licensePlates })
    })
  }

  listLicensePlates () {
    licensePlateApi.list(metas => {
      if (!metas) return
      const licensePlatesData = licensePlateService.tableHorizontalData(metas)
      this.setState({ licensePlates: licensePlatesData })
    })
  }

  componentDidMount () {
    this.listLicensePlates()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Custom license plate numbers (LPNs)")}
              doc='license-plates'>
              <Button
                text={i18n("Upload")}
                onClick={this.handleUploadClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.headers}
              data={this.state.licensePlates}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(LicensePlates)
